export default {"src":"/_next/static/media/42-icon.20637e63.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};